import { Droplets, Truck, Zap, Clock } from "lucide-react";
import { STORE } from "@/lib/store";

const ABOUT_IMG = "https://images.pexels.com/photos/12917478/pexels-photo-12917478.jpeg";

const POINTS = [
    { Icon: Zap, title: "Electrical expertise", body: "Wire gauges, MCB ratings, switch modules — we help you spec the right electrical parts." },
    { Icon: Droplets, title: "Plumbing know-how", body: "PVC vs CPVC, tap types, valve sizes — practical advice for every job." },
    { Icon: Truck, title: "Pan-India delivery", body: "We ship electrical and plumbing supplies across India for qualifying orders." },
    { Icon: Clock, title: "Available 7 days a week", body: "Long weekday hours and a shorter Sunday shift for urgent site needs." },
];

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="bg-white py-24 md:py-32 border-y border-border">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <div className="lg:col-span-6 relative">
                    <div className="relative rounded-3xl overflow-hidden border border-border aspect-[4/5] shadow-xl">
                        <img src={ABOUT_IMG} alt="Plumbing and electrical supplies" className="w-full h-full object-cover" loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 to-transparent" />
                    </div>
                    <div className="absolute -top-6 -right-6 hidden md:block rounded-2xl bg-safety text-white p-5 shadow-xl w-52">
                        <p className="text-[10px] uppercase tracking-[0.25em] font-bold">Serving since</p>
                        <p className="font-display font-black text-5xl leading-none mt-1">{STORE.since}</p>
                        <p className="text-xs mt-2 text-white/80">Trusted by builders for {new Date().getFullYear() - STORE.since}+ years.</p>
                    </div>
                </div>

                <div className="lg:col-span-6">
                    <p className="uppercase tracking-[0.3em] text-xs font-semibold text-safety mb-4">/02 · About us</p>
                    <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-5xl lg:text-6xl text-charcoal leading-[1.05]">
                        India's electrical & plumbing supply partner.
                    </h2>
                    <p className="mt-6 text-muted-foreground leading-relaxed max-w-xl">
                        Since {STORE.since}, we've helped electricians, plumbers and contractors
                        source the right wire, switches, pipes and fittings — fast. From a single
                        MCB to a full bathroom plumbing list, we quote on WhatsApp and deliver
                        across {STORE.serviceArea}.
                    </p>

                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {POINTS.map(({ Icon, title, body }) => (
                            <div key={title} className="border border-border rounded-xl p-5 hover:border-safety transition-colors bg-background">
                                <div className="w-10 h-10 rounded-lg bg-safety/10 text-safety grid place-items-center mb-3">
                                    <Icon className="w-5 h-5" />
                                </div>
                                <h3 className="font-display font-bold text-lg text-charcoal">{title}</h3>
                                <p className="text-sm text-muted-foreground mt-1">{body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
